import React from "react";
import {
  required,
  translate,
  List,
  Datagrid,
  TextField,
  Filter,
  TextInput,
  Create,
  SimpleForm,
  Edit,
  DisabledInput,
  Toolbar,
  SaveButton,
  Pagination
} from "react-admin";
import compose from "recompose/compose";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PageTitle from "../../components/PageTitle";
import {
  rowsPerPageOptions,
  defaultRowsPerPageOption
} from "../../utils/paging";
import PopupBulkDeleteButton from "../../components/PopupBulkDeleteButton";
import CustomToolbar from "../../components/CustomToolbar";

const LevelFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
  </Filter>
);

export const LevelList = compose(translate)(({ translate, ...props }) => (
  <Grid>
    <PageTitle title={translate("resources.levels.listPage.headline")} />
    <List
      filters={<LevelFilter />}
      exporter={false}
      pagination={
        <Pagination rowsPerPageOptions={rowsPerPageOptions} {...props} />
      }
      bulkActionButtons={<PopupBulkDeleteButton />}
      perPage={defaultRowsPerPageOption}
      {...props}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
      </Datagrid>
    </List>
  </Grid>
));

export const LevelCreate = compose(translate)(
  ({ translate, history, ...props }) => (
    <Grid>
      <PageTitle title={translate("resources.levels.createPage.headline")} />
      <Create {...props}>
        <SimpleForm redirect="list" toolbar={<CustomToolbar {...props} />}>
          <TextInput source="name" validate={required()} />
        </SimpleForm>
      </Create>
    </Grid>
  )
);

export const LevelEdit = compose(translate)(
  ({ translate, history, ...props }) => (
    <Grid>
      <PageTitle title={translate("resources.levels.editPage.headline")} />
      <Edit {...props}>
        <SimpleForm
          redirect="list"
          toolbar={<CustomToolbar disabledDelete {...props} />}
        >
          <DisabledInput label="Id" source="id" />
          <TextInput source="name" validate={required()} />
        </SimpleForm>
      </Edit>
    </Grid>
  )
);
